import { styled } from '@mui/system';
import { Button, Paper, Typography } from '@mui/material';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { getContrastColor } from '#component/theme';

export const ErrorContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => ({
  ...(hasError && {
    outline: `2px solid ${theme.palette.error.main}`,
    outlineOffset: 5
  })
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1)
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  '&:empty': {
    display: 'none'
  }
}));

export const AddButtonContainer = styled('div')(() => ({
  paddingTop: 12
}));

export const AddButtonIcon = styled(AddCircleOutlineRoundedIcon)(() => ({
  color: getContrastColor()
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const ButtonContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'isIntersecting' && prop !== 'shipmentModuleEnabled'
})(({ theme, isIntersecting, shipmentModuleEnabled }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: shipmentModuleEnabled ? 'space-between' : 'end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  // borderTop and shadow only if not intersecting
  ...(isIntersecting ? {} : {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));

export const ValuesTitleCnt = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const ValuesTitle = styled(Typography)(() => ({
  fontSize: '1rem'
}));

export const ValuesSubTitle = styled(Typography)(() => ({
  fontSize: 12,
  color: '#0000008a'
}));

export const CustomFieldValueCnt = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '24px 0'
}));
